import * as React from 'react';
import styled from 'styled-components';

import { themeGet } from '../../../theme/utils';
import { AutoSuggestHit } from '../AutosuggestList';
import { parseAlgoliaHit } from '../utils';

export const Match = styled.span`
  color: ${themeGet.colors('kilamanjaro')};
  font-weight: ${themeGet.fontWeight('bold')};
`;

export const Muted = styled.span`
  color: ${themeGet.colors('sandDune')};
  font-weight: ${themeGet.fontWeight('normal')};
`;

export const Normal = styled.span;

export const Highlight: React.FC<{ hit: AutoSuggestHit; attribute: string }> = ({ hit, attribute }: any) => (
  <React.Fragment>
    {parseAlgoliaHit({ hit, attribute }).map((highlight) =>
      !highlight.isHighlighted ? (
        <Match key={highlight.value} data-testid="autosuggest-highlight-match">
          {highlight.value}
        </Match>
      ) : (
        <Muted key={highlight.value} data-testid="autosuggest-highlight-muted">
          {highlight.value}
        </Muted>
      ),
    )}
  </React.Fragment>
);
